import { ArrowUpIcon } from "lucide-react";

import { Row } from "@/components/Row";
import { Text } from "@/components/Text";

// Cute lil ^N indicator to show change since last visiting that job
export const DeltaBadge = ({ delta }: { delta: number }) => {
  if (delta <= 0) return null;

  const render = () => (
    <Row className="items-center gap-px leading-none text-emerald-500">
      <Text className="text-[11px] font-medium tabular-nums leading-none text-emerald-500">
        {delta}
      </Text>
      <ArrowUpIcon className="h-3 w-3" strokeWidth={2.5} />
    </Row>
  );

  return render();
};
